var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-grow-1 justify-space-between"},[_c('div',{staticClass:"d-flex justify-end align-center"},[_vm._t("tools-left")],2),_c('div',{staticClass:"d-flex justify-end align-center"},[_vm._t("tools-right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }